/* eslint-disable react/display-name, react/prop-types, import/no-cycle */
import React from "react"
import { Hidden } from "@material-ui/core"
import VerticalLayout from "./dashboard/layouts/VerticalLayout"
import HorizontalLayout from "./dashboard/layouts/HorizontalLayout"
import TabPanelLayout from "./dashboard/layouts/TabPanelLayout"
import DashboardElement from "./dashboard/DashboardElement"

export default function withRecursiveLayout(Component) {
  return (props) => {
    const { data, children, title, HorizontalLayoutProps, ...rest } = props
    const { responsive } = HorizontalLayoutProps || {}

    if (!data?.layout) {
      return <Component {...props} />
    }

    if (data.layout.includes("vertical")) {
      return (
        <VerticalLayout {...rest} data={data} Component={DashboardElement} />
      )
    }
    if (data.layout.includes("horizontal")) {
      // FIXME MLa : Est-ce que la responsivité est aussi faisable pour le VerticalLayout ?
      if (responsive === true) {
        return (
          <>
            <Hidden only={["md", "lg", "xl"]}>
              <VerticalLayout
                {...rest}
                data={data}
                Component={DashboardElement}
              />
            </Hidden>

            <Hidden only={["xs", "sm"]}>
              <HorizontalLayout
                {...rest}
                data={data}
                Component={DashboardElement}
              />
            </Hidden>
          </>
        )
      }
      return (
        <HorizontalLayout {...rest} data={data} Component={DashboardElement} />
      )
    }
    if (data.layout.includes("tabpanel")) {
      return (
        <TabPanelLayout {...rest} data={data} Component={DashboardElement} />
      )
    }
    throw new Error(`Invalid Layout: ${data.layout}`)
  }
}
